<i18n src='@/locale/password-localization.json'></i18n>

<template>
    <v-wm-form-dialog
        :formTitle="$t('Change_Password')"
        @cancel="$emit('cancel')"
        @save="ValidateAndChange"
    >
        <v-form
            ref="passwordForm"
            v-model="valid"
            lazy-validation
            @submit.prevent="ValidateAndChange"
        >
            <v-row dense>
                <v-col>
                    <v-text-field
                        v-model="oldPassword"
                        :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showOld ? 'text' : 'password'"
                        @click:append="showOld = !showOld"
                        :label="$t('Old_Password')"
                        :rules="[rules.required]"
                        dense
                        outlined
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <v-text-field
                        v-model="newPassword"
                        :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNew ? 'text' : 'password'"
                        @click:append="showNew = !showNew"
                        :label="$t('New_Password')"
                        :rules="[rules.required]"
                        dense
                        outlined
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <v-text-field
                        v-model="confirmPassword"
                        :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showConfirm ? 'text' : 'password'"
                        @click:append="showConfirm = !showConfirm"
                        :label="$t('Confirm_New_Password')"
                        :rules="[rules.required, rules.confirmMatch]"
                        dense
                        outlined
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </v-wm-form-dialog>
</template>

<script>
import VWmFormDialog from '@/component/form-dialog.vue';
import userProfileService from '@/service/user-profile-service';

export default {
    components: {
        VWmFormDialog,
    },
    props: {},
    data() {
        return {
            oldPassword: null,
            newPassword: null,
            confirmPassword: null,

            showOld: false,
            showNew: false,
            showConfirm: false,

            valid: true,
            rules: {
                required: (value) => !!value || this.$t('Field_Required'),
                confirmMatch: () =>
                    this.newPassword === this.confirmPassword ||
                    this.$t('Passwords_Dont_Match'),
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        ValidateAndChange() {
            this.$refs.passwordForm.validate();

            this.$nextTick(() => {
                if (this.valid) {
                    userProfileService
                        .changePassword(this.oldPassword, this.newPassword)
                        .then(() => {
                            this.$emit('save');
                        });
                }
            });
        },
    },
};
</script>

<style>
</style>